module.exports = __webpack_public_path__ + "img/P31.4512b377.png";